module.exports = __webpack_public_path__ + "img/badge-highest-revenue-keyvue-blue.3d1c43d1.png";